import React, { useState, useEffect } from 'react'
import { Tabs, Row, Col, Button, Spin, message } from 'antd'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import FilePreview from '../FilePreview'
import { withRouter } from 'react-router-dom'
import * as API from '../../../api'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { addQuickcreate } from '../../../redux/reducers/quickGenerate'

import './index.less'
const { TabPane } = Tabs

const business = {
	1: '酒店商品库',
	6: '民宿商品库',
	2: '景区商品库',
	5: '知识产权数据库',
	7: '创意文案库',
	3: '同程艺龙旅行公众号',
	4: '同程艺龙研发中心公众号',
	8: '攻略图文数据库',
	9: '酒店点评数据库'
}
const businessKey = {
	'酒店商品库': 'jd',
	'景区商品库': 'jq',
	'民宿商品库': 'ms',
	'知识产权数据库': 'zs',
	'创意文案库': 'wa'
}
const dataTypeName = {
	'image_list': '图片',
	'video_list': '视频',
	'text_list': '文字',
}
const LeadBusinessResult = (props) => {
	const { showQuickEnter } = props
	const { businessIdList , sug } = props.businessParams
	const [businessNameList, setBusinessNameList] = useState([])
	const [checkList, setCheckList]= useState({})
	const [businessData, setBusinessData] = useState({})
	const [loading, setLoading] = useState(false)
	const [dataType, setDataType] = useState('image_list')
	const [businessType, setBusinessType] =useState(businessKey[business[businessIdList[0]]])
	const [pageNo, setPageNo] = useState(1)
	const [haveNextPage, setHaveNextPage]= useState(true)
	const [confirmVideoLoading, setConfirmVideoLoading] = useState(false)
	const [confirmArticleLoading, setConfirmArticleLoading] = useState(false)
	const [previewVisible, setPreviewVisible] = useState(false)
	const [previewInfo, setPreviewInfo] = useState({ content: '', type: '图片' })
	useEffect(() => {
		const businessNameList = []
		const idList = businessIdList
		idList.length && idList.forEach(id => {
			businessNameList.push(business[id])
		})
		setBusinessType(businessKey[business[businessIdList[0]]])
		setBusinessNameList(businessNameList)
	},[businessIdList])
	useEffect(() => {
		props.submit && props.submit(checkList)
	},[checkList])
	const searchBusiness = async (pageno) => {

		if(sug == '') return
		setLoading(true)
		setBusinessData({})
		const { code, msg, data } = await API.getEtlSearch({
			page_no: pageno,
			page_size: 10,
			sug: sug.indexOf('；') !== -1 ? sug.replace(/；/, ';') : sug,
			is_list: businessIdList
		})
		setPageNo(pageno)
		setLoading(false)
		if(code === 0) {
			const keys = Object.values(businessKey)
			let isHaveNextPage = false
			for(let i = 0; i < keys.length; i++) {
				if(JSON.stringify(data[keys[i]]) !== '{}') {
					isHaveNextPage= true
					break
				}
			}
			setHaveNextPage(isHaveNextPage)
			setBusinessData(data)
		} else {
			message.error(msg)
		}
	}

	useEffect(() => {
		searchBusiness(1)
	},[sug])

	const changeDataType = (type) => {
		setDataType(type)
	}
	const changeBusinessType = (type) => {
		setBusinessType(businessKey[type])
		setDataType('image_list')
	}
	const handleSetPreviewInfo = (content, type) => {
		setPreviewInfo({ content, type })
		setPreviewVisible(true)
	}
	const inCheckList = (value, id) => {
		const newCheckList = JSON.parse(JSON.stringify(checkList))
		if(newCheckList[businessType] && newCheckList[businessType][dataType]) {
			const dataList = newCheckList[businessType][dataType]
			for(let j = 0; j < dataList.length; j ++) {
				if(dataList[j].id === id) {
					const urlData = dataList[j].data
					for(let i = 0; i < urlData.length; i ++) {
						if(urlData[i] === value || urlData[i] === value) {
							return i
						}
					}
				}
			}
		}
		return -1
	}
	const checkOne = (value, id) => {
		const newCheckList = JSON.parse(JSON.stringify(checkList))
		const idx = inCheckList(value, id)
		if(idx !== -1) {
			// 存在 删除
			const dataList = newCheckList[businessType][dataType]
			for(let i = 0; i < dataList.length; i++) {
				if(dataList[i].id === id) {
					dataList[i].data.splice(idx,1)
					console.log(newCheckList)
					setCheckList(newCheckList)
					return
				}
			}
		} else {
			// 不存在 添加
			if(!newCheckList[businessType]) newCheckList[businessType] = {}
			if(!newCheckList[businessType][dataType]) newCheckList[businessType][dataType] = []
			const dataList = newCheckList[businessType][dataType]
			let flag = false
			for(let i = 0; i < dataList.length; i++) {
				if(dataList[i].id === id) {
					flag = true
					dataList[i].data.push(value)
					console.log(newCheckList)
					setCheckList(newCheckList)
					return
				}
			}
			if(!flag) {
				dataList.push({
					data: [value],
					id
				})
				console.log(newCheckList)
				setCheckList(newCheckList)
			}
		}
	}
	const checkAll = (id, isInCheckAll) => {
		const newBusinessData = JSON.parse(JSON.stringify(businessData))
		const dataList = newBusinessData[businessType][dataType]
		const newCheckList = JSON.parse(JSON.stringify(checkList))
		if(!newCheckList[businessType]) newCheckList[businessType] = {}
		if(!newCheckList[businessType][dataType]) newCheckList[businessType][dataType] = []
		const newCheckListData = newCheckList[businessType][dataType]
		console.log(newCheckList)
		for(let i = 0; i < dataList.length; i++) {
			if(dataList[i].id === id) {
				// 全选的数据 加上index参数
				const data = dataList[i].data
				for(let j = 0; j < data.length; j++) {
					data[j] = `${data[j]}?index=${j}`
				}
				let flag = false
				for(let m = 0; m < newCheckListData.length; m ++) {
					if(newCheckListData[m].id === id) {
						flag = true
						if(isInCheckAll) {
							// 取消全选
							newCheckListData.splice(m,1)
						} else {
							// 全选
							newCheckListData[m].data = data
						}
						console.log(newCheckList)
						setCheckList(newCheckList)
						return
					}
				}
				if(!flag) {
					newCheckListData.push({
						data,
						id
					})
				}
				console.log(newCheckList)
				setCheckList(newCheckList)
				return
			}
		}
	}
	const inCheckAll = (id) => {
		const currentBusinessList = businessData[businessType][dataType]
		let currentCheckList = []
		if(checkList[businessType] && checkList[businessType][dataType]) {
			currentCheckList = checkList[businessType][dataType]
		}
		if(currentCheckList.length === 0) {
			return false
		}
		let currentCheckData = []
		let currentBusinessData = []
		for(let i = 0; i < currentCheckList.length; i++) {
			if(currentCheckList[i].id === id) {
				currentCheckData = currentCheckList[i].data
			}
		}
		for(let i = 0; i < currentBusinessList.length; i++) {
			if(currentBusinessList[i].id === id) {
				currentBusinessData = currentBusinessList[i].data
			}
		}
		if(currentCheckData.length === currentBusinessData.length) {
			return true
		} else {
			return false
		}
	}
	const imageNode = (key) => {
		let imageList = businessData[key].image_list
		if(key == 'zs') {
			imageList = [{
				data: businessData[key].image_list,
				id: 1111111111,
			}]
		}
		return (
			<>
				{
					imageList.map((item,index) => (
						<React.Fragment  key={index}>
							{item.data && item.data.length > 0 &&
								<Row gutter={[10, 10]} className="common-module-area">
									{
										item.data.map((url, index) => (
											<React.Fragment  key={index}>
												{(url.indexOf('.JPG') > -1 || url.indexOf('.PNG') > -1 || url.indexOf('.jpg') > -1 || url.indexOf('.png') > -1) &&
													<Col span={3} className="common-item image-item">
														<div className="common-item-inner">
															<img src={url} alt={url} onClick={() => handleSetPreviewInfo(url, '图片')}/>
															<div className={`ant-checkbox ${inCheckList(`${url}?index=${index}`, item.id) !== -1 && 'ant-checkbox-checked'}`} onClick={() => checkOne(`${url}?index=${index}`,item.id)}>
																<span className="ant-checkbox-inner"></span>
															</div>
														</div>
													</Col>
												}

											</React.Fragment>
										))
									}
								</Row>
							}
						</React.Fragment>
					))
				}
			</>
		)
	}
	const videoNode = (key) => {
		let videoList = businessData[key].video_list
		if(key == 'zs') {
			videoList = [{
				data: businessData[key].video_list,
				id: new Date().getTime(),
			}]
		}
		return (
			<>
				{
					videoList.map((item, index) => (
						<React.Fragment key={index}>
							{item.data && item.data.length > 0 &&
								<Row gutter={[10, 10]} className="common-module-area">
									{
										item.data.map((url, index) => (
											<Col span={3} key={index} className="common-item video-item">
												<div className="common-item-inner">
													<video src={url} onClick={() => handleSetPreviewInfo(url, '视频')}/>
													<div className={`ant-checkbox ${inCheckList(`${url}?index=${index}`, item.id) !== -1 && 'ant-checkbox-checked'}`} onClick={() => checkOne(`${url}?index=${index}`,item.id)}>
														<span className="ant-checkbox-inner"></span>
													</div>
												</div>
											</Col>
										))
									}
								</Row>
							}
						</React.Fragment>
					))
				}
			</>
		)
	}
	const textNode = (key) => {
		let textList = businessData[key].text_list
		if(key == 'zs') {
			textList = [{
				data: businessData[key].text_list,
				id: new Date().getTime(),
			}]
		}
		return (
			<>
				{
					textList.map((item, index) => (
						<React.Fragment key={index}>
							{item.data && item.data.length > 0 &&
								<div className="common-module-area">
									{
										item.data && item.data.map((text,index) => (
											<div key={index} className="common-item text-item">
												<div className="common-item-inner" onClick={() => handleSetPreviewInfo(text, '文章')}>
													{text}
													<div className={`ant-checkbox ${inCheckList(text, item.id) !== -1 && 'ant-checkbox-checked'}`} onClick={() => checkOne(text,item.id)}>
														<span className="ant-checkbox-inner"></span>
													</div>
												</div>
											</div>
										))
									}
								</div>
							}
						</React.Fragment>
					))
				}
			</>
		)
	}
	const batchCheckNode = () => {
		if(businessData[businessType] && businessData[businessType][dataType] && businessData[businessType][dataType].length > 0 && businessType !== 'zs') {
			const batchList = businessData[businessType][dataType]
			return (
				<div className="bath-check-area">
					{
						batchList.map((item, index) => (
							<React.Fragment key={index}>
								{item.data && item.data.length > 0 ?
									<div className="check-item">
										<div className="check-item-inner">
											<label onClick={() => checkAll(item.id, inCheckAll(item.id))}>
												<div className={`ant-checkbox ${inCheckAll(item.id) && 'ant-checkbox-checked'}`}>
													<span className="ant-checkbox-inner"></span>
												</div>
												<span className="all">全选</span>
											</label>
											<div>{item.name}</div>
										</div>
									</div>
									:
									<></>
								}
							</React.Fragment>
						))
					}
				</div>
			)
		}	else {
			return(<></>)
		}
	}
	const checkListCount = (type) => {
		let count = 0
		if(JSON.stringify(checkList) !== '{}') {
			Object.values(businessKey).map(key => {
				if(checkList[key] && checkList[key][type]) {
					const dataList = checkList[key][type]
					dataList.forEach(item => {
						count = count + item.data.length
					})
				}
			})
		}
		return count
	}
	const tabNode = (name, isNew) => {
		return (
			<>{name} {isNew && <span className="tab-new"></span>}</>
		)
	}
	const businessTab = (type) => {
		let tabName = tabNode(type, false)
		if(businessData[businessKey[type]]) {
			Object.keys(dataTypeName).map(item => {
				const dataList = businessData[businessKey[type]][item]
				if(dataList) {
					for(let i = 0; i < dataList.length; i++) {
						// 知识产权数据结构没有.data
						if((dataList[i].data && dataList[i].data.length > 0) || dataList[i].length > 0) {
							tabName = tabNode(type, true)
							break
						}
					}
				}
			})
		}
		if(type === '创意文案库') {
			if(businessData[businessKey[type]] && businessData[businessKey[type]].length > 0) {
				tabName = tabNode(type, true)
			}
		}
		return tabName
	}

	const dataTypeTab = (businesstype, dataType) => {
		let tabName = tabNode(dataTypeName[dataType], false)
		if(businessData[businessKey[businesstype]]) {
			try {
				businessData[businessKey[businesstype]][dataType].forEach(list => {
					// 知识产权数据结构没有.data
					if((list.data && list.data.length > 0) || list.length > 0) {
						tabName = tabNode(tabName, true)
						throw Error()
					}
				})
			} catch(e){}
		}
		return tabName
	}
	const goToPage = (type) => {
		searchBusiness(type === 'next' ? pageNo + 1 : pageNo - 1 > 0 ? pageNo - 1 : 1 )
	}
	const handleSubmitValue = () => {
		const result = []
		let listIndex = 0
		const submitValue = JSON.parse(JSON.stringify(checkList))
		const businesskeys = Object.values(businessKey)
		const typeKeys = Object.keys(dataTypeName)
		console.log(businesskeys,typeKeys,submitValue)
		businesskeys.forEach(business => {
			if(submitValue[business]) {
				typeKeys.forEach(type => {
					const dataList = submitValue[business][type]
					console.log(dataList)
					if(submitValue[business][type] && dataList) {
						dataList.forEach(item => {
							if(item.data) {
								item.data.forEach(url => {
									result.push({
										st_fileurl: url.slice(0,url.lastIndexOf('?')),
										type: dataTypeName[type],
										// 选择素材排序用
										sort: listIndex,
										key: listIndex
									})
									listIndex++
								})
							}
						})
					}
				})
			}
		})
		console.log(result)
		return result
	}
	const quickCreate = async (type) => {
		console.log('handleSubmit')
		const isVideo = type === 'video'
		isVideo ? setConfirmVideoLoading(true) : setConfirmArticleLoading(true)
		try {
			const submitValue = handleSubmitValue()
			console.log(submitValue)
			const replaceUrl = async (item: { st_fileurl: any; type: string }, i: number) => {
				const { st_fileurl: url } = item
				const params = { fileurl: url }
				if(
					!url.endsWith('.JPG') &&
					!url.endsWith('.PNG') &&
					!url.endsWith('.jpg') &&
					!url.endsWith('.png')
				) {
					if(item.type === '图片') params.st_format = 'jpg'
				}
				const { code, data } = await API.addFileForUrl(params)
				if (code === 0) {
					submitValue[i].st_fileurl = data
				} else {
					message.error('链接转换出错')
				}
			}
			const promises = submitValue.map((item, i) => replaceUrl(item, i))
			await Promise.all(promises)
			console.log(submitValue)
			const id = new Date().getTime()
			props.actions.addQuickcreate({
				id,
				value: isVideo ? {st_second_vedio:submitValue} : submitValue
			})
			props.history.push(`/main/create/${type}?quick=${id}`)
		} catch (error) {
			console.log(error)
		}
		isVideo ? setConfirmVideoLoading(false) : setConfirmArticleLoading(false)
	}
	const handlePreviewVisible = (val) => {
		setPreviewVisible(val)
	}
	useEffect(() => {
		batchCheckNode()
	}, [businessType, dataType])
	const pagination = () => {
		return (
			<>
				{	JSON.stringify(businessData) !== '{}' &&
					<div className="business-pagination">
						<Button type="primary" onClick={() => goToPage('prev')} disabled={pageNo === 1}>上一页</Button>
						<Button type="primary" onClick={() => goToPage('next')} disabled={!haveNextPage}>下一页</Button>
					</div>
				}

			</>
		)
	}

	const mainNode = () => {
		return (
			<Spin spinning={loading}>
				<div className="business-main-wrap business-main-wrap-tile">
					{businessType !== 'wa' &&
						<div className="check-list-info">
							{/* 共找到<span>{2033}</span>条搜索结果， */}
								已选中<span>{checkListCount('image_list')}</span>个图片，<span>{checkListCount('video_list')}</span>个视频，<span>{checkListCount('text_list')}</span>段文字
						</div>
					}
					{
						showQuickEnter &&
						<div className="one-btn-area">
							<Button type="primary" loading={confirmVideoLoading} onClick={() => quickCreate('video')}>一键生成视频</Button>
							<Button type="primary" loading={confirmArticleLoading} onClick={() => quickCreate('article')}>一键生成图文</Button>
						</div>
					}
					<Tabs onChange={(key) => changeBusinessType(key)}>
						<>
							{
								businessNameList.map(business => (
									<TabPane
										key={business}
										tab={businessTab(business)}
										disabled={business === '攻略图文数据库' || business === '酒店点评数据库'}
									>
										<div className="business-card-container">
											{((businessData[businessKey[business]] && businessData[businessKey[business]].image_list && businessData[businessKey[business]].image_list.length > 0) || (businessData[businessKey[business]] && businessData[businessKey[business]].video_list && businessData[businessKey[business]].video_list.length > 0) || (businessData[businessKey[business]] && businessData[businessKey[business]].text_list && businessData[businessKey[business]].text_list.length > 0)) ?
												<Row>
													<Col span={ business === '知识产权数据库' ? 0 : 3 }>{batchCheckNode()}</Col>
													<Col span={ business === '知识产权数据库' ? 24 : 21 }>
														<Tabs type="card" onChange={(key) => changeDataType(key)}>
															{(businessData[businessKey[business]] && businessData[businessKey[business]].image_list && businessData[businessKey[business]].image_list.length > 0) &&
															<TabPane tab={dataTypeTab(business, 'image_list')} key="image_list">
																<div className="tab-pane-container">
																	{imageNode(businessKey[business])}
																</div>
															</TabPane>}
															{businessType === 'jd' &&
																<>
																	{(businessData[businessKey[business]] && businessData[businessKey[business]].video_list && businessData[businessKey[business]].video_list.length > 0) && <TabPane tab={dataTypeTab(business, 'video_list')} key="video_list">
																		<div className="tab-pane-container">
																			{videoNode(businessKey[business])}
																		</div>
																	</TabPane>}
																	{(businessData[businessKey[business]] && businessData[businessKey[business]].text_list && businessData[businessKey[business]].text_list.length > 0) &&<TabPane tab={dataTypeTab(business, 'text_list')} key="text_list">
																		<div className="tab-pane-container">
																			{textNode(businessKey[business])}
																		</div>
																	</TabPane>}
																</>
															}

														</Tabs>
													</Col>
												</Row>
												: business === '创意文案库' && businessData[businessKey[business]] && businessData[businessKey[business]].length > 0 ?
													businessData[businessKey[business]].map((item, index) => {
														return (
															<div key={index} className="creativity-text">
																{item.text}
																<CopyToClipboard
																	text={item.text}
																	onCopy={() => message.info('复制成功')}
																>
																	<span className="creativity-copy">
																		复制
																	</span>
																</CopyToClipboard>
															</div>
														)
													})
													: <div className="no-data" style={{minHeight: '400px'}}>暂无搜索结果</div>
											}
										</div>
									</TabPane>
								))
							}
						</>
					</Tabs>
					{pagination()}
					{/* 预览 */}
					<FilePreview
						{...previewInfo}
						visible={previewVisible}
						handleVisible={handlePreviewVisible}
					/>
				</div>
			</Spin>
		)
	}
	return (
		mainNode()
	)
}
LeadBusinessResult.defaultProps = {
	showQuickEnter: false,
	businessParams: {
		businessIdList: [1,2,6,5],
		sug: ''
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({
			addQuickcreate,
		}, dispatch)
	}
}

export default connect(null, mapDispatchToProps)(withRouter(LeadBusinessResult))